import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogTitle, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'ciwc-order-confirm-change-ca',
  imports: [MatButton, MatDialogActions, MatDialogContent, MatDialogTitle],
  standalone: true,
  templateUrl: './order-confirm-change-ca.component.html',
  styleUrl: './order-confirm-change-ca.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderConfirmChangeCaComponent {
  constructor(
    public dialogRef: MatDialogRef<OrderConfirmChangeCaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
